import { queryOptions } from "@tanstack/react-query"
import axios from "axios"
import { DataResponse, KnowledgeSuggestionsResponseDataSchema } from "schema"
import { z } from "zod"

export type KnowledgeSuggestion = z.infer<typeof KnowledgeSuggestionsResponseDataSchema>[number]

export const knowledgeSuggestionsQuery = () =>
  queryOptions({
    queryKey: ["knowledgeSuggestions"],
    queryFn: async () => {
      const { data } = await axios.get<DataResponse<KnowledgeSuggestion[]>>(
        "/knowledgeBase/suggestions",
      )
      return data.data
    },
    refetchInterval: (query) =>
      query.state.data?.some(({ status }) => status === "pending") ? 10000 : false,
  })
